export default __webpack_public_path__ + "static/media/glassystem.353f277a.jpg";